export default "__VITE_ASSET__XQPYnT_E__"